const pageTitles: {[key: string]: number | string} = {
  '/home': 'Home',
  '/library': 'Library',
  '/browse': 'Browse',
  '/feed': 'Feed',
  '/settings': 'Settings',
  '/update_account': 'Update Account',
  '/login': 'Login',
  '/search': 'Search',
  '/logout': 'Logout',
  '/library/recent': 'Recently Added',
  '/library/songs': 'Songs',
  '/library/artists': 'Artists',
  '/library/albums': 'Albums',
  '/library/playlists': 'Playlists',
};

export default pageTitles;
